import { render, staticRenderFns } from "./EventCreation.vue?vue&type=template&id=54be1f28&scoped=true&"
import script from "./EventCreation.vue?vue&type=script&lang=js&"
export * from "./EventCreation.vue?vue&type=script&lang=js&"
import style0 from "./EventCreation.vue?vue&type=style&index=0&id=54be1f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be1f28",
  null
  
)

export default component.exports